export default __webpack_public_path__ + "static/media/YouTube.52cd74c8.svg";